// src/services/profileService.js
import axios from "./axiosConfig";

// GET profile data
export const getProfile = () => {
  return axios.get("/profile/111"); // Returns a Promise
};

// UPDATE profile data
export const updateProfile = (id, profileData) =>
  axios.put(`/profile/${id}`, profileData);
